import axios from "axios";

export const fetchReport = async (excelRequest, url) => {
	const result = await axios.post(url, excelRequest);
	return result;
};

export const setBlobFromData = (data) => {
	const blob = new Blob([s2ab(atob(data))], {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
	});
	return blob;
};

const s2ab = (s) => {
	const buf = new ArrayBuffer(s.length);
	const view = new Uint8Array(buf);
	for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
};

export const configureSheet = (activeSheet, spread) => {
	activeSheet.options.isProtected = true;
	activeSheet.options.colHeaderVisible = false;
	activeSheet.options.rowHeaderVisible = false;
	if (spread != null) {
		spread.refresh();
	}
};

export const spreadActiveSheetChanged = (type, sheetInfo) => {
	const sheet = sheetInfo.newSheet;
	configureSheet(sheet);
};